<template>
  <div
    v-if="showAcquirerIcon"
    class="eu-ml_1"
  >
    <emd-tippy
      v-if="showTippy"
      position="top"
      aria-expanded="true"
      type="html"
      data-testid="emd-tippy-dash-info-icon"
      :id="tooltipId"
      :data-template="tooltipId"
      :key="dataType"
    >
      <em class="emd-text _color_success uil uil-info-circle" />
      <emd-tippy-template-HTML :id="tooltipId">
        <emd-text
          v-for="item in tooltipItems"
          :key="item.name"
          size="tiny"
          data-testid="emd-text-dash-info-icon"
        >
          {{ $t(item.name) }}
          <b class="_type_bold">: {{ getValue(item) }}</b>
          <br />
        </emd-text>
      </emd-tippy-template-HTML>
    </emd-tippy>
  </div>
</template>

<script>
import {
  EmdText,
  EmdTippy,
  EmdTippyTemplateHTML
} from 'emerald-vue/src/components'

import { DASHBOARD_DATA_TYPE_ENUM } from '../../../enums/dash-progress-data-type.enum'

export default {
  name: 'AcquirerTooltip',

  components: {
    EmdText,
    EmdTippy,
    EmdTippyTemplateHTML
  },

  props: {
    dataIcon: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        tooltip: []
      })
    },
    dataType: {
      type: String,
      default: () => DASHBOARD_DATA_TYPE_ENUM.PERCENTAGE,
      validation: type => Object.keys(DASHBOARD_DATA_TYPE_ENUM).includes(type)
    }
  },

  data () {
    return {
      tooltipId: 'acquirer_info-tippy'
    }
  },

  computed: {
    showAcquirerIcon () {
      return this.dataIcon?.name.includes('tooltip')
    },
    showTippy () {
      return this.dataIcon?.tooltip?.length > 0
    },
    tooltipItems () {
      return this.dataIcon?.tooltip
    }
  },

  methods: {
    getValue ({ percentage, value }) {
      return this.dataType === DASHBOARD_DATA_TYPE_ENUM.PERCENTAGE
        ? percentage + '%'
        : value
    }
  }
}
</script>
